import { COOKIE } from '@iva/utils';
import { decodePurposeOne } from './cmpone';
import { logger } from './logger';
export var CONSENT_COOKIE_NAME = 'euconsent-v2';
export var CONSENT_PURPOSE_ONE_COOKIE_NAME = 'szncmpone';
export var CONSENT_COOKIE_NAMES = [
    CONSENT_COOKIE_NAME,
    'eupubconsent-v2',
    'ibb_euconsent',
    'gdpr_consent',
    'sas_cmp_cookie_consentData',
    'csent',
];
export var PurposeId = {
    /**
     * Purpose one is not supposed to be saved to purposeLegitimateInterests because we have purposeOneTreatment true,
     * but it should be saved to purposeConsents, because RTB needs it.
     */
    COOKIE: 1,
    // implicit consent
    BASIC_ADS: 2,
    MEASURE_ADS: 7,
    MEASURE_PERFORMANCE: 8,
    MARKET_RESEARCH: 9,
    IMPROVE: 10,
    // user choice
    ADS_PROFILE: 3,
    ADS: 4,
    CONTENT_PROFILE: 5,
    CONTENT: 6,
};
export var hasPurposeOne = function (consentString) {
    if (typeof consentString !== 'string') {
        return false;
    }
    return decodePurposeOne(consentString);
};
var getResult = function (euconsentString, name) {
    return {
        version: 'v2',
        consentString: euconsentString,
        name: name,
        purposeOne: hasPurposeOne(euconsentString),
    };
};
// wait for TCF API v2 for TCData
var receivedTCFData = '';
var listeningTCFApi = false;
var receiverCallbackList = [];
var tcCallback = function (tcData, success) {
    if (success && tcData.eventStatus === 'useractioncomplete') {
        // do something with tcData.tcString
        receivedTCFData = tcData.tcString;
        var result = getResult(receivedTCFData);
        for (var _i = 0, receiverCallbackList_1 = receiverCallbackList; _i < receiverCallbackList_1.length; _i++) {
            var receiverCallback = receiverCallbackList_1[_i];
            receiverCallback(result);
        }
        logger('debug', "got successful tcfapi response, called ".concat(receiverCallbackList.length, " callbacks"));
        receiverCallbackList.length = 0;
    }
};
var hasTCFApi = function () { return typeof window.__tcfapi === 'function'; };
// listen to TCF api (just once)
var listenToTCFApi = function () {
    if (hasTCFApi() && !listeningTCFApi) {
        listeningTCFApi = true;
        window.__tcfapi('addEventListener', 2, tcCallback);
    }
};
listenToTCFApi();
/**
 * Get consent TCF cookie from predefined list.
 * @param receiverCallback if set you can wait until consent is set using TCF API v2
 * or you get no result it mean there is no TCF API
 * @returns Object ConsentResult from existing cookie or null if not found.
 */
export var getConsentFromCookieList = function (receiverCallback) {
    // in some cases TCF api is available after some time -> attach listener (if not already attached)
    listenToTCFApi();
    var euconsent = undefined;
    var cookieName = undefined;
    for (var _i = 0, CONSENT_COOKIE_NAMES_1 = CONSENT_COOKIE_NAMES; _i < CONSENT_COOKIE_NAMES_1.length; _i++) {
        var cookie = CONSENT_COOKIE_NAMES_1[_i];
        var cookieValue = COOKIE.getCookie(cookie);
        if (cookieValue) {
            cookieName = cookie;
            euconsent = cookieValue;
            break;
        }
    }
    var euconsentString = null;
    if (euconsent) {
        euconsentString = euconsent;
    }
    else if (receivedTCFData) {
        euconsentString = receivedTCFData;
    }
    else if (typeof receiverCallback === 'function') {
        if (hasTCFApi()) {
            receiverCallbackList.push(receiverCallback);
        }
        else {
            receiverCallback();
        }
    }
    return euconsentString ? getResult(euconsentString, cookieName) : null;
};
export var hasPurposeOneFromCookieList = function () {
    var consent = getConsentFromCookieList();
    return consent ? hasPurposeOne(consent.consentString) : false;
};
